import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { rotate } from './keyframes';

const Sizes = {
    normal: css`
        & {
            font-size: 1em;
        }

        &,
        &:before,
        &:after {
            width: 2.28571429rem;
            height: 2.28571429rem;
        }

        &:before,
        &:after {
            margin: 0em 0em 0em -1.14285714rem;
        }
    `,
    massive: css`
        & {
            font-size: 1.71428571em;
        }

        &,
        &:before,
        &:after {
            width: 4.57142857rem;
            height: 4.57142857rem;
        }

        &:before,
        &:after {
            margin: 0em 0em 0em -2.28571429rem;
        }
    `,
};

const SizeNames = Object.keys(Sizes);

const Loader = styled.div.attrs((props) => ({
    size: SizeNames.includes(props.size) ? props.size : 'normal',
    className: 'spinner',
}))`
    position: relative;
    vertical-align: middle;
    margin: 0em;
    left: 0em;
    top: 0em;
    text-align: center;
    z-index: 1;
    transform: none;
    margin: 0 auto;

    &:before {
        position: absolute;
        content: '';
        top: 0%;
        left: 50%;
        width: 100%;
        height: 100%;
        border-radius: 500rem;
        border: 0.2em solid rgba(0, 0, 0, 0.1);
    }

    &:after {
        position: absolute;
        content: '';
        top: 0%;
        left: 50%;
        width: 100%;
        height: 100%;
        animation: ${rotate} 0.6s linear;
        animation-iteration-count: infinite;
        border-radius: 500rem;
        border-color: ${(props) => props.secondaryColor || '#767676'} transparent transparent;
        border-style: solid;
        border-width: 0.2em;
        box-shadow: 0px 0px 0px 1px transparent;
    }

    ${(props) => Sizes[props.size] || Sizes.normal}
    ${(props) =>
        props.centered &&
        css`
            margin-left: auto;
            margin-right: auto;
        `}
`;

export default Loader;

Loader.propTypes = {
    secondaryColor: PropTypes.string,
    size: PropTypes.oneOf(SizeNames),
    centered: PropTypes.bool,
};
